export default "__VITE_ASSET__2u_Rve$A__"